import { render, staticRenderFns } from "./PromotionAnalytics.vue?vue&type=template&id=3ae652a2"
import script from "./PromotionAnalytics.vue?vue&type=script&lang=js"
export * from "./PromotionAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports